module.exports = {
  title: 'Clock Time Picker with Reanimated & Skia',
  author: 'Enzo Manuel Mangano',
  date: '2025-03-25',
  slug: 'clock-time-picker',
  tags: ['skia', 'reanimated'],
};
